import { StateNode, TLKeyboardEventInfo, TLPointerEventInfo } from "tldraw"

export class Idle extends StateNode {
  static override id = "idle"

  fill = false

  override onPointerDown(pointerInfo: TLPointerEventInfo) {
    this.parent.transition("pointing", {
      ...pointerInfo,
      fill: this.fill,
    })
  }

  override onEnter(info: { fill: boolean }) {
    this.editor.setCursor({ type: "cross", rotation: 0 })
    this.fill = info.fill ?? false
  }

  override onKeyUp(info: TLKeyboardEventInfo) {
    if (info.key === "Enter") {
      if (this.editor.getIsReadonly()) return null

      const onlySelectedShape = this.editor.getOnlySelectedShape()
      // If the only selected shape is editable, start editing it
      if (
        onlySelectedShape &&
        this.editor.getShapeUtil(onlySelectedShape).canEdit(onlySelectedShape)
      ) {
        this.editor.setCurrentTool("select")
        this.editor.setEditingShape(onlySelectedShape.id)
        this.editor.root.getCurrent()?.transition("editing_shape", {
          ...info,
          target: "shape",
          shape: onlySelectedShape,
        })
      }
    }
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }
}
